import { DEMO_APPOINTMENT_SOURCE, demoAppointmentIdsStorageKey } from './constants';
import { listAppointments, deleteAppointmentApi } from '../api/appointments';

export async function clearDemoAppointments(companyId, { isSpecialAdmin = false } = {}) {
  if (!isSpecialAdmin) {
    throw new Error('Demo appointments are available to special admins only.');
  }

  const storageKey = demoAppointmentIdsStorageKey(companyId);
  const storedRaw = window.localStorage.getItem(storageKey);
  const storedIds = storedRaw ? JSON.parse(storedRaw) : [];

  const result = await listAppointments({ companyId, archived: 'all' });
  const fromQuery = (result.appointments || []).filter(
    (appointment) => appointment.source === DEMO_APPOINTMENT_SOURCE
  );
  const knownIds = new Set(fromQuery.map((appointment) => appointment.id));
  const trackedIds = storedIds.filter((id) => !knownIds.has(id));
  const idsToDelete = [...fromQuery.map((appointment) => appointment.id), ...trackedIds];

  let deleted = 0;
  for (const id of idsToDelete) {
    try {
      await deleteAppointmentApi({ companyId, id });
      deleted += 1;
    } catch (error) {
      if (error?.status !== 404) throw error;
    }
  }

  window.localStorage.removeItem(storageKey);

  if (deleted === 0) {
    return {
      deleted: 0,
      message: storedIds.length > 0
        ? 'No demo appointments were removed (they may have been deleted already).'
        : 'No demo appointments found for this company.',
    };
  }

  return {
    deleted,
    message: `Removed ${deleted} demo appointment${deleted === 1 ? '' : 's'}.`,
  };
}
